import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, MenuItem } from 'react-pro-sidebar'
import { useTranslation } from 'contexts/Localization'
import { menuItemsConfig } from '../config/config'

interface MainMenuProps {
  closeSidebar: () => void
}

const MainMenu: React.FC<MainMenuProps> = ({ closeSidebar }) => {
  const { t } = useTranslation()
  const menuItems = menuItemsConfig(t)
  const location = useLocation()
  const pathname = location.pathname || location.location.pathname

  const activeMenuItemHref = menuItems
    .map(({ href }) => href)
    .sort((hrefA, hrefB) => hrefB.length - hrefA.length) // We sort to find longest routes first
    .find((href) => pathname.startsWith(href))

  return (
    <Menu iconShape="square">
      {menuItems.map(({ label, href, IconComponent }) => {
        const isActive = href === activeMenuItemHref
        return (
          <MenuItem
            active={isActive}
            icon={IconComponent && <IconComponent color="currentColor" />}
            key={`menu-item-${label}`}
          >
            <Link onClick={closeSidebar} to={href}>
              {label}
            </Link>
          </MenuItem>
        )
      })}
    </Menu>
  )
}

export default MainMenu
